import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DataViewModule } from 'primeng/dataview';
import { RatingModule } from 'primeng/rating';
import { TagModule } from 'primeng/tag';
import { GeneralEmitterService } from '../../services/general-emitter.service';
import { ProductService } from '../../services/product.service';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { AdressFormComponent } from '../adress-form/adress-form.component';
import { OrdersService } from '../../services/orders.service';
import { statusValue } from '../../../assets/statusValue';

@Component({
  selector: 'app-cart-detail',
  standalone: true,
  imports: [DataViewModule, ButtonModule, TagModule, RatingModule, CommonModule,
    ToastModule, AdressFormComponent
  ],
  providers: [MessageService],
  templateUrl: './cart-detail.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styleUrl: './cart-detail.component.scss'
})
export class CartDetailComponent {
  @Input() showDetail = true;
  
  products: any = [];
  x= 0;
  layout = 'list';
  value3: number = 1;
  listItems: any[] = [];
  listOrder: any[] = [];
  total: number = 0;
  section: number = 1;
  address: any = null;
  lastOrder: any = 0;
  usr: any = localStorage.getItem('usr') || '';
  statusValue = statusValue;

  constructor(
    private productService: ProductService,
    private emitterData: GeneralEmitterService,
    private messageService: MessageService,
    private ordersService: OrdersService
  ) {
  }
  
  async ngOnInit() {
    this.products = JSON.parse(localStorage.getItem('productCart') || '[]');
    this.section = this.products.length > 0 ? 1 : 0;
    this.usr = localStorage.getItem('usr') || '';
    await this.getLastOrder();    
    await this.orderProducts();
    await this.getTotal();
  }
  
  ngAfterViewInit(): void {
    this.emitterData.chartData.emit(true);
  }

  orderProducts() {
    this.listItems = [];
    this.listOrder = [];

    this.products.forEach((item: any) => {
      let sku = this.listItems.find((val: any) => val.sku == item.sku);
      let skuOrder = this.listOrder.find((val: any) => val.sku == item.sku);
      if ( !sku ) {
        let newItem = item;
        let newOrder = {
          sku: item.sku,
          product: item.nombre,
          quantity: 1,
          unit_price: item.precioUnitario,
          user_id: this.usr,
          address_id: this.address?.id
        };
        newItem.cantidad = 1;
        this.listItems.push(newItem);
        this.listOrder.push(newOrder);
      } else {
        sku.cantidad++;
        skuOrder.quantity++;
      }
    });
  }

  add(evt: any) {
    this.listItems[evt].cantidad++;
    this.getTotal();
  }

  less(evt: any) {
    this.listItems[evt].cantidad--;
    this.getTotal();
  }

  deleteProduct(ix: any) {
    this.products.forEach((rem: any, index: any) => {
      console.log(ix);
      if ( rem.sku == this.listItems[ix].sku ) {
        this.products.splice(index, 1);
      }
    })
    this.listItems.splice(ix, 1);
    this.getTotal();
  }

  async getLastOrder() {
    await this.ordersService.getLastOrder().subscribe({
      next: (res:any) => {
        this.lastOrder = Number(res.order) + 1;
      },
      error: (err: any) => {
        if ( err?.status == 401 ) {
          this.messageService.add({ severity:'error', summary: 'Ocurrió un error', detail: "Su sesión ha expirado, por favor inicie sesión nuevamente." });
        }
      }
    });
  }

  getTotal() {
    this.total = 0;
    this.listItems.forEach((item: any) => {
      this.total += item.cantidad * item.precioUnitario;
    });
  }

  getAddress(item: any) {
    this.address = item;
    this.listOrder.forEach((ord: any) => {
      ord.order = this.lastOrder;
      ord.address_id = this.address?.id;
    });
  }

  saveOrder() {
    if ( this.address.length != 0 || this.listOrder.length != 0 ) {
      let payload = { 'orders': this.listOrder};
      this.ordersService.saveOrder(payload).subscribe({
        next: (res:any) => {
          this.messageService.add({ severity:'success', summary: 'Solicitud Enviada', detail: "La información será validada, en breve enviaremos su cotización final" });
          localStorage.removeItem('productCart');
          this.listItems = [];
          this.getTotal();
          this.section = 3;
          this.emitterData.chartData.emit(true);
        }
      });
    }
  }
}
